'use strict';

export default class SearchGlobalQuick {
    constructor() {

        /*        
        Changed on 22/12/2022
        Disabling the global quick search to reduce algolia 

        */
        console.log('Alogolia fix 147');
        return false;


        // var renderIndexListItem, renderAutocomplete, customAutocomplete;


        // let $template_html;
        // let $index_name = 'search_contents';
        // let $app_id = 'PV21YPDECK';
        // let $app_key = '999fc9d3376250fbb4c0d870bb15e65c';
        // let $search_box_element = "#search-box";
        // let $search_container = ".search-bar";
        // let $page_size = 5;
        // let $speechSupported = false;




        // // Change the index based on the user logged in
        // $('.current-user-role.personal_member').length ? $index_name = 'search_contents_personal_member' : '';
        // $('.current-user-role.volunteer').length ? $index_name = 'search_contents_volunteer' : '';
        // $('.current-user-role.staff').length ? $index_name = 'search_contents_volunteer' : '';
        // $('.current-user-role.administrator').length ? $index_name = 'search_contents_volunteer' : '';

        // console.log('Current admin div:', $('.current-user-role.administrator').length);
        // console.log('Current search index:', $index_name);

        // let $containers = {
        //     pagingation: '#pagination',
        //     search_box: '.search-bar.quick',
        //     search_box_placeholder: 'Search',
        //     search_result: '#results',
        //     facets: '#facets',
        //     facets_clear: '#facets-clear',
        //     voice_search: '#voice-search',
        //     search_container: '.search-box-elements',
        //     sorting: '#search_sorting',
        //     stats: '#search_stats',
        // }

        // // If we have a container then load
        // if (haveSearchContainer()) {
        //     bindShowHideSearchBar();
        //     checkIfSpeechSupported();
        //     // buildTemplates();
        //     doBunchOfStuff();
        //     loadAlgoliaSearch();
        // }

        // // alert('Search-global-quick');


        // function debounce(callback, delay) {
        //     let timeout;
        //     return function () {
        //         clearTimeout(timeout);
        //         timeout = setTimeout(callback, delay);
        //     }
        // }

        // function doBunchOfStuff() {


        //     // Helper for the render function
        //     function renderIndexListItem($result) {
        //         // console.log($result);
        //         var $html = "";
        //         $result.hits.forEach(function ($index, $hit) {
        //             var $item = ($result.hits[$hit]);

        //             $html += "<li><a href='" + $item.url + "'>" + instantsearch.highlight({ attribute: 'title', hit: $item }) + "</a></li>"
        //         });
        //         return $html;
        //     }

        //     // renderIndexListItem = ({ indexId, hits }) => `
        //     //     ${hits.map((hit, hitIndex) => `<li><p>${instantsearch.highlight({ attribute: 'title', hit })}</p></li>`).join('')}
        //     // `;

        //     // Create the render function
        //     renderAutocomplete = (renderOptions, isFirstRender) => {
        //         const { indices, currentRefinement, refine, widgetParams } = renderOptions;


        //         function refinelist() {
        //             refine(document.getElementById("search-box-quick-text").value);
        //         }

        //         if (isFirstRender) {
        //             const input = document.getElementById("search-box-quick-text");
        //             const ul = document.getElementById("autocomplete-list");

        //             input.addEventListener('input', debounce(refinelist, 600));
        //         }

        //         widgetParams.container.querySelector('#search-box-quick-text').value = currentRefinement;
        //         widgetParams.container.querySelector('#autocomplete-list').innerHTML = indices
        //             .map(renderIndexListItem)
        //     };

        //     // Create the custom widget
        //     customAutocomplete = instantsearch.connectors.connectAutocomplete(
        //         renderAutocomplete
        //     );

        // }

        // function loadAlgoliaSearch() {

        //     let searchClient = algoliasearch($app_id, $app_key);

        //     let $search = instantsearch({
        //         indexName: $index_name,
        //         searchClient,
        //         routing: {
        //             stateMapping: instantsearch.stateMappings.simple(),
        //         },
        //     });

        //     $search.addWidgets([

        //         instantsearch.widgets.configure({
        //             hitsPerPage: $page_size,
        //             attributesToSnippet: ['body:30'],
        //         }),

        //         // Voice search
        //         instantsearch.widgets.voiceSearch({
        //             container: $containers.voice_search,
        //             searchAsYouSpeak: true,
        //             templates: {
        //                 status: `
        //                   <div class="listening {{isListening}}"><img src="/themes/aba/images/ripple.pink.svg"></div>
        //                 `,
        //             },
        //         }),

        //         // instantsearch.widgets.index({ indexName: $index_name }),

        //         customAutocomplete({
        //             showReset: true,
        //             autofocus: true,
        //             container: document.querySelector('.search-bar.quick'),
        //         })
        //     ]);

        //     $search.start();

        //     $search.on('render', function () {
        //         console.log('Algolia search complete');
        //         displayAutoCompleteList();
        //     });
        // }

        // function displayAutoCompleteList() {
        //     if ($('#search-box-quick-text').val()) {
        //         $('#autocomplete-list').show();
        //     } else {
        //         $('#autocomplete-list').hide();
        //     }
        // }

        // function checkIfSpeechSupported() {
        //     if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
        //         console.log('speech recognition API supported')
        //         $($containers.search_container).addClass('speech-supported');
        //         $speechSupported = true;
        //     } else {
        //         console.log('speech recognition API not supported');
        //     }

        // }

        // function haveSearchContainer() {
        //     if (!$($containers.search_box).length) {
        //         return false;
        //     } else {
        //         return true;
        //     }
        // }

        // function bindShowHideSearchBar() {

        //     $('.global-search-link').click(function ($event) {
        //         $event.preventDefault();

        //         if ($(this).hasClass('active')) {
        //             $(this).removeClass('active');
        //             removeQuickSearchContainer();
        //         } else {
        //             $(this).addClass('active');
        //             addQuickSearchContainer()
        //         }
        //     })
        // }


        // function removeQuickSearchContainer() {
        //     $('#block-searchelementquicksearchbar').hide();
        // }

        // function addQuickSearchContainer() {
        //     $('#block-searchelementquicksearchbar').show();
        //     $('#search-box-quick-text').focus();
        // }
    }
}
